// extracted by mini-css-extract-plugin
export default {"page":"sT","heading":"tT","subheading":"uT","flavorbox":"vT","inner":"wT","image":"xT","label":"yT","flavorselect":"zT","arrow":"AT","flavorswrap":"BT","flavorsheader":"CT","flavorsnav":"ET","flavorsinner":"FT","cancelbtn":"GT","flavorsbottom":"HT","retakebtn":"IT","continueBtn":"JT","drawerinner":"KT","videowrap":"LT","flavorsbottomnav":"MT"};
    if(module.hot) {
      // 1715276859491
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  